var appendScript = scriptURL => {
  if (document) {
    var currentScript = document.querySelector("#altapay_checkout_script");

    if (!currentScript) {
      var head = document.querySelector("head");
      var script = document.createElement("script");
      script.type = "module";
      script.setAttribute("id", "altapay_checkout_script");
      script.src = scriptURL;

      if (head) {
        head.append(script);
      }
    }
  }
};

export { appendScript };
//# sourceMappingURL=append-altapay-script.js.map
